import { createContext } from 'react';

interface DropdownMenuContextValue {
  closeModal: () => void;
  isTriggered: boolean;
  /**
   * Used to keep track of the current nesting level in order to
   * determine the z-index of submenus.
   */
  currentNestingLevel: number;
}

export const DropdownMenuContext = createContext<DropdownMenuContextValue>({
  closeModal: () => {},
  isTriggered: false,
  currentNestingLevel: 0,
});

DropdownMenuContext.displayName = 'DropdownMenuContext';
